module.exports = __webpack_public_path__ + "static/media/bg.d9c6998b.jpg";